import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function ImprintPage() {
  const { i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CookieBanner />

      <section className="pt-32 pb-24">
        <div className="max-w-[800px] mx-auto px-10">
          <h1
            className="text-5xl font-bold text-[#0A2D50] mb-12"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {i18n.language === 'de' ? 'Impressum' : i18n.language === 'es' ? 'Aviso Legal' : 'Legal Notice'}
          </h1>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4">
              {i18n.language === 'de' ? 'Angaben gemäß § 5 TMG' : i18n.language === 'es' ? 'Información según § 5 TMG' : 'Information according to § 5 TMG'}
            </h2>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              DR Group GmbH<br />
              In der Gottesau 4<br />
              76646 Bruchsal<br />
              Germany
            </p>

            <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4 mt-12">
              {i18n.language === 'de' ? 'Vertreten durch' : i18n.language === 'es' ? 'Representado por' : 'Represented by'}
            </h2>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              {i18n.language === 'de' ? 'Geschäftsführer' : i18n.language === 'es' ? 'Director Gerente' : 'Managing Director'}: David Rico
            </p>

            <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4 mt-12">
              {i18n.language === 'de' ? 'Kontakt' : i18n.language === 'es' ? 'Contacto' : 'Contact'}
            </h2>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              E-Mail: <a href="mailto:info@group-dr.com" className="text-[#1BCDFF] hover:text-[#1EB7EC] cursor-pointer">info@group-dr.com</a><br />
              {i18n.language === 'de' ? 'Telefon' : i18n.language === 'es' ? 'Teléfono' : 'Phone'}: <a href="tel:+491708843942" className="text-[#1BCDFF] hover:text-[#1EB7EC] cursor-pointer">+49 170 8843 942</a>
            </p>

            <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4 mt-12">
              {i18n.language === 'de' ? 'Registereintrag' : i18n.language === 'es' ? 'Entrada de Registro' : 'Register Entry'}
            </h2>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              {i18n.language === 'de' ? 'Registergericht' : i18n.language === 'es' ? 'Tribunal de Registro' : 'Register Court'}: Amtsgericht Mannheim<br />
              {i18n.language === 'de' ? 'Registernummer' : i18n.language === 'es' ? 'Número de Registro' : 'Register Number'}: {i18n.language === 'de' ? 'wird nachgetragen' : i18n.language === 'es' ? 'por añadir' : 'to be added'}
            </p>

            <h2 className="text-2xl font-semibold text-[#0A2D50] mb-4 mt-12">
              {i18n.language === 'de' ? 'Verbraucherstreitbeilegung' : i18n.language === 'es' ? 'Resolución de Disputas de Consumidores' : 'Consumer Dispute Resolution'}
            </h2>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              {i18n.language === 'de' 
                ? 'Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
                : i18n.language === 'es'
                ? 'No estamos obligados ni dispuestos a participar en procedimientos de resolución de disputas ante una junta de arbitraje de consumidores.'
                : 'We are not obliged and not willing to participate in dispute resolution proceedings before a consumer arbitration board.'}
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}